import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IHeroCreation} from "../types/IHeroCreation";
import {AdCreationError} from "./creation_error_class";

export async function fetchHeroAd(creationId: number) {
    try {
        const url = apiV2Link.adverts.hero.detail({heroId: creationId});
        const creationDetails = await getRequest(clientRpRequestMeta, url);

        return creationDetails as IHeroCreation;
    } catch (error) {
        notifyBugsnag(error, "fetchHeroAd: catch", {originalError: JSON.stringify(error)});

        throw new AdCreationError(`creation ${creationId} not found`);
    }
}
